import { connect } from 'react-redux';
import { getHeights, getInputDataToSend } from '../../../../store/form/selectors';
import { setInputDataToSend } from '../../../../store/form/actions';
import HeightSection from './HeightSection';
import { getLoader } from '../../../../store/loader/selectors';

const mapStateToProps = (state) => ({
  loader: getLoader(state),
  heights: getHeights(state),
  inputData: getInputDataToSend(state),
});

const mapDispatchToProps = (dispatch) => ({
  setInputDataToSend: (key, data) => {
    dispatch(setInputDataToSend(key, data));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(HeightSection);
